module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAATCAYAAACp65zuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAINJREFUeNpiYICC////CwDx/P/YgQMDkkJcisAKGZEU/mfADRxZoIoMsEg2AvEBKPsCC5QhgEXhAUZGRphCBhaoadhMNIC5BqwByNn/Hz+4D1LMxEAYPCBW4QdYsIDcUoDFSpCYAxArIAe2A97YINLqEayQEZa6sSSMC8DE8AHGAQgwAAYQsBZaTgIuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialImg/facebookLogo.png
// module id = 561
// module chunks = 153596302435155